import { Suspense, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ReactLoader } from '@/app/NextLoader';
import { LoaderFull, Viewport } from '@/components';
import { useRemainingFreeTrialDays } from '@/features/admin-interview/useRemainingFreeTrialDays';
import { EnvHint } from '@/features/devtools';

const useChangingLanguage = () => {
  const [isChangingLanguage, setIsChangingLanguage] = useState(false);
  const { i18n } = useTranslation();

  i18n.on('languageChanged', () => {
    setIsChangingLanguage(true);
  });

  return isChangingLanguage;
};

export function RootLayout() {
  const isChangingLanguage = useChangingLanguage();

  const path = useLocation();
  const navigate = useNavigate();
  const { isDemoCompany, remainingTrialDays } = useRemainingFreeTrialDays();

  useEffect(() => {
    if (
      isDemoCompany &&
      remainingTrialDays <= 0 &&
      path.pathname !== '/admin/dashboard'
    ) {
      navigate('/admin/dashboard');
    }
  }, [isDemoCompany, path.pathname, navigate, remainingTrialDays]);

  if (isChangingLanguage) {
    return (
      <Suspense>
        <Viewport>
          <LoaderFull />
        </Viewport>
      </Suspense>
    );
  }

  return (
    <Suspense>
      <Viewport>
        <ReactLoader />
        <Outlet />
        <EnvHint />
      </Viewport>
    </Suspense>
  );
}
